module.exports = __webpack_public_path__ + "vue/img/icon-02.72843f09.png";